// `/market/moderation/$caseId` — one case. Founder-only on the gateway
// (requireSystemFounder); a case id that names nothing, or one a non-founder
// has no business seeing, answers the same 404/403 either way.
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/moderation/$caseId')({});
